import { createSlice } from '@reduxjs/toolkit';

import { resetAll } from 'store/reset';

const initialState = {
  userData : {
    medical : null,
  },
};

const userSlice = createSlice({
  name     : 'user',
  initialState,
  reducers : {
    setUserMedicalData : (state, action) => {
      state.userData.medical = action.payload;
    },
  },
  extraReducers : (builder) =>
    builder.addCase(resetAll.type, () => initialState),
});

export const { setUserMedicalData } = userSlice.actions;

export default userSlice;
